import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import StyledElement from './StyledElement'

const PADDING = '8px'
const DEFAULT_DESKTOP_HEIGHT = '36px'
const DEFAULT_MOBILE_HEIGHT = '44px'

const mediaScreenMobile = props => `@media screen and (min-width: ${props.theme.screens.medium})`
const inputHeight = ({ height }) => height

const CardInputContainer = styled.div`
    width: 100%;
    position: relative;
`

const CardInputWrapper = styled.div`
    .CardInput {
        background: transparent;
        border: 0;
        margin: 0;
        padding: 14px ${PADDING} 0 ${PADDING};
        width: 100%;
        height: ${inputHeight};
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: ${DEFAULT_MOBILE_HEIGHT};

        ${mediaScreenMobile} {
            height: ${inputHeight};
            padding-top: 0;
        }
    }
`

CardInputWrapper.propTypes = {
    height: PropTypes.string,
}

class CardInput extends React.Component {
    static propTypes = {
        cardElement: PropTypes.func.isRequired,
        onFocus: PropTypes.func,
        onBlur: PropTypes.func,
        onChange: PropTypes.func,
        height: PropTypes.string,
        forceFocus: PropTypes.bool,
    }

    static defaultProps = {
        onChange: () => {},
        height: DEFAULT_DESKTOP_HEIGHT,
    }

    onChange = this.onChange.bind(this)
    onReady = this.onReady.bind(this)

    focus () {
        this.element && this.element.focus()
    }

    onChange (changes) {
        // Simulate native change event
        const event = {
            target: {
                value: changes,
            },
        }

        this.props.onChange(event)
    }

    onReady (element) {
        this.element = element
    }

    componentDidUpdate ({ forceFocus }) {
        if (!forceFocus && this.props.forceFocus) {
            this.focus()
        }
    }

    render () {
        const { cardElement, onFocus, onBlur, height } = this.props

        return (
            <CardInputContainer>
                <CardInputWrapper height={height}>
                    <StyledElement
                      cardElement={cardElement}
                      onFocus={onFocus}
                      onBlur={onBlur}
                      onChange={this.onChange}
                      onReady={this.onReady}
                    />
                </CardInputWrapper>
            </CardInputContainer>
        )
    }
}

export default CardInput
